/* eslint-disable better-mutation/no-mutation */
import { createSlice } from '@reduxjs/toolkit';
import { NS_ATTRIBUTES, NS_TOUCHWEB } from 'tradera/lang/constants.mjs';

type TranslationKeyValue = Record<string, string>;
type NamespaceTranslations = Record<string, TranslationKeyValue>;

export type TranslationsState = {
    renderedKeys: NamespaceTranslations;
};

export const initialState: TranslationsState = {
    renderedKeys: {
        [NS_TOUCHWEB]: {},
        [NS_ATTRIBUTES]: {}
    }
};

const slice = createSlice({
    name: 'translations',
    initialState,
    reducers: {
        addTranslationKey: (state, { payload }) => {
            const { namespace, key, translation } = payload;
            state.renderedKeys[namespace][key] = translation;
        }
    }
});

export const { addTranslationKey } = slice.actions;
export const reducer = slice.reducer;
